<template>
  <div>
    <AppHeader />
    <FeaturesList />
    <ImageGallery />
    <RoadmapSection />
    <ContactForm />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import FeaturesList from "@/components/FeaturesList.vue";
import ImageGallery from "@/components/ImageGallery.vue";
import RoadmapSection from "@/components/RoadmapSection.vue";
import ContactForm from "@/components/ContactForm.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "HomeView",
  components: {
    AppHeader,
    FeaturesList,
    ImageGallery,
    RoadmapSection,
    ContactForm,
    AppFooter,
  },
};
</script>

<style scoped>
/* Add any additional styles if needed */
</style>
